import React, { useEffect } from 'react'
import { useLocation } from 'react-router'
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'

import reloadImg from '@/assets/common/reload.png'
import InputForm from '@/shared/components/common/CommonForm/InputForm'
import { TYPE_SECURITY } from '@/shared/constant/cmdtype'
import { COLOR } from '@/shared/constant/color'
import { useSecurityQueryData } from '@/shared/hooks/reactquery'
import useOnInput from '@/shared/hooks/useOnInput'
import useSubscriptQuery from '@/shared/hooks/useSubscriptQuery'
import useValid from '@/shared/hooks/useValid'
import { SecurityNumState, SecurityTranIdState } from '@/shared/store'
import { ModalBtn } from '@/styles/common/CommonForm/buttonform'
import { ModalConfirmContent, ModalDefaultTitle } from '@/styles/common/modal'
import { SecurityContent, SecurityWrap } from '@/styles/common/sercurity'

const SecurityModal = (props: any) => {
  const { isOpen, ClickFunc, ClickFunc2, ClickFunc3, ClickFunc4, ClickFunc5 } = props //ClickFunc: toggle() ClickFunc2: douToggle()
  const { pathname } = useLocation()
  const onInput = useOnInput()
  const valid = useValid()
  const SecurityNum = useRecoilValue(SecurityNumState)
  const ResetSecurityNumState = useResetRecoilState(SecurityNumState)
  const setSecurityTranId = useSetRecoilState(SecurityTranIdState)
  const { data: SecurityData, mutate: SecurityReceive } = useSecurityQueryData(TYPE_SECURITY)
  const subscript = useSubscriptQuery()

  const SecurityConfirmFunc = () => {
    switch (pathname) {
      case '/join':
        subscript.joinSecureSubmit(ClickFunc2, ClickFunc)
        break
      case '/cancel':
        subscript.cancelSecureSubmit(ClickFunc2, ClickFunc)
        break
      case '/refund':
        subscript.refundSecureSubmit(ClickFunc2, ClickFunc, ClickFunc3, ClickFunc4, ClickFunc5)
        break
    }
  }
  useEffect(() => {
    SecurityData?.Body?.TranID && setSecurityTranId(SecurityData?.Body?.TranID)
  }, [SecurityData?.Body?.TranID, SecurityReceive, setSecurityTranId])

  useEffect(() => {
    ResetSecurityNumState()
    SecurityReceive()
  }, [ResetSecurityNumState, SecurityReceive, isOpen])

  return (
    <>
      <ModalConfirmContent>
        <SecurityWrap>
          <ModalDefaultTitle>하단의 보안문자를 입력하세요.</ModalDefaultTitle>
          <SecurityContent>
            <section>
              {SecurityData?.Body?.ImgB64 && (
                <img
                  src={`data:image/png;base64, ${SecurityData?.Body?.ImgB64 && SecurityData?.Body?.ImgB64}`}
                  alt="보안문자 이미지"
                />
              )}
            </section>
            <img src={reloadImg} alt="새로고침" onClick={() => SecurityReceive()} />
            <InputForm
              title=""
              valid={valid.SecurityValid}
              placeholder="보안문자 입력"
              value={SecurityNum}
              oninput={onInput.SecurityNum}
              blurFunc={valid.onBlurForValidationCert}
              errMsg="보안문자 입력을 확인해주세요."
            />
          </SecurityContent>
          <p>※ 화면에 출력된 문자를 정확하게 입력 해 주세요.</p>
        </SecurityWrap>
        <section>
          <ModalBtn bgColor={COLOR.blueGray3} onClick={ClickFunc}>
            <span>취소</span>
          </ModalBtn>
          <ModalBtn bgColor={COLOR.point1} onClick={SecurityConfirmFunc}>
            <span>확인</span>
          </ModalBtn>
        </section>
      </ModalConfirmContent>
    </>
  )
}
export default SecurityModal
